import { cn } from "@/lib/utils";
import { readableTextColor } from "../domain/deals/stageModel";
import { useStageColor } from "./useDealStages";
import { useStageLabel } from "./useStageLabel";

/** The stage as a badge in its colour; the text is dark or white, whichever contrasts more (spec §4). */
export const StageBadge = ({
  stage,
  className,
}: {
  stage: string;
  className?: string;
}) => {
  const label = useStageLabel()(stage);
  const color = useStageColor()(stage);
  return (
    <span
      data-stage={stage}
      className={cn(
        "inline-flex max-w-full items-center truncate rounded-full px-2 py-0.5 text-xs font-semibold",
        className,
      )}
      style={{ backgroundColor: color, color: readableTextColor(color) }}
    >
      {label}
    </span>
  );
};

/** A dot in the stage's colour (stage history, funnel table, stage select). */
export const StageDot = ({ stage }: { stage: string }) => {
  const color = useStageColor()(stage);
  return (
    <span
      aria-hidden="true"
      data-stage-dot={stage}
      className="inline-block size-2.5 shrink-0 rounded-full"
      style={{ backgroundColor: color }}
    />
  );
};
